<!--首页中部广告轮播-->
<template>
  <div class="indexBrandMuseum" :option="option">
    <template v-if="init && option.length != 0">
        <div v-if="option.length <= 1" style="height: 100%">
          <img @click="goSearchList(option[0])" :src="option[0]['coverIcon']" />
        </div>
        <template v-else>
          <swiper :options="swiperOption" class="swiper-container-topBanner">
            <swiper-slide class="swiper-slide-topBanner" v-for="(item, index) in option" :key="index"  @click="goSearchList(item)">
              <img :options="JSON.stringify(item)" :src="item.coverIcon" />
            </swiper-slide>
          </swiper>
        </template>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

let vm = null
export default {
  props: {
    option: {
      type: [Object, String, Array],
      default: () => ''
    }
  },
  components: {},
  data() {
    return {
      swiperOption: {
        loop: true,
        speed: 800,
        autoplay: {
          disableOnInteraction: false,
        },
        on: {
          click: function(e) {
            let options = e.target.getAttribute('options')
            if (!options) return
            options = JSON.parse(options)
            vm.goSearchList(options)
          }
        },
        lazy: {
          loadPrevNext: true,
        },
      },
      init:false
    }
  },
  computed: {
    ...mapGetters(['subjectType', 'info'])
  },
  mounted() {
    vm = this
    setTimeout(()=>{
      this.init=true
    }, 50)
  },
  methods: {
    goLogin(){
      if (this.subjectType == '') {
        this.$store.commit('SET_SUBJECTTYPE', '')
        this.loginSource('/login/person')
      }
    },
    goSearchList(param){
      let status = this.$config.settings.onlayReg2
      if (!status) {
        this.commonStatistics('001032000', param)
      }
      window.PC.$RangersEvent("home_waistCarousel_detailsbutton_click", {
        carouselmap_id: param.id
      }, () => {
        /**
         * EXTERNAL       外部链接
         * ACTOR_DETAILS  展商详情
         * TAG_EXHIBITOR  展商列表
         */
        if (param.urlType == 'EXTERNAL') {
          if (param.url === '') {
            return
          } else {
            window.open(param.url, '_blank')
          }
        } else {
          if (status) {
            this.goLogin()
            return 
          }
          if (param.urlType=="ACTOR_DETAILS"){
            this.pageDetail(param, 'actor')
          } else if (param.urlType == "TAG_EXHIBITOR"){
            sessionStorage.setItem('findListActor',param.url)
            this.$router.push({ path: '/find/actor' })
          } else {
            console.log('暂时没有匹配操作')
          }

        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.swiper-container-topBanner {
  height: 100%;
}
img{
  display block
  margin auto
  width 100%
  height: 100%;
  object-fit cover;
  cursor:pointer
}
</style>
